import React, { Component } from "react";
//import { Link } from "react-router-dom";

import { connect } from "react-redux";
import format from "date-fns/format";
import writtenNumber from "written-number";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import Paginator from "../paginator/Paginator";
import { resetForm ,} from "../../actions/commonAction";
import { openModal } from "../../actions/modalAction";
import * as actions from "../../actions/financeAction";
import PurchaseBookEdit from "./PurchaseBookEdit";
import FinanceEditToAccept from "./FinanceEditToAccept";
import AddViewImageContra from "../image/AddViewImageContra";
import {renderMonth,capitalizeFirst,
  //renderPreviousMonth,
} from "../functions/Functions";
import { getMonth,getYear } from 'date-fns'
import { 
  Table,
  Container,
  Divider,
  Segment,
  //Input,
  //Button,
  Label,
  Popup,
  Confirm,
  Icon,
  Modal,
} from "semantic-ui-react";
import AllFinanceSA from './AllFinanceSA'
//import AdFindprop from "../advertisement/AdFindprop";


class PurchaseBook extends Component {
  state = {
    pageO:'',
    id: "",
    idOfContraEntry:'',
    path:"",
    imagePathContra:[],
    checkedStatus:'',
    entryFor:'',
    entryType:'',
    open: false,
    allFinanceSAModalOpen: false,
    result: "show the modal to capture a result",
    renderType: "Payment",
     editModalOpen: false,
     addViewImageModalOpen: false,
     viewPdfModalOpen:false,
     financeEditToAcceptModalOpen: false,
   
      monthNum:getMonth(new Date()),
      year:getYear(new Date()),
      monthWord:''
   
  }; 
  
  componentDidMount() {
    
    const {limit} = this.props
    const values = {entryType: 'Purchase', month:renderMonth(this.state.monthNum),  ...(this.props.form !== undefined && this.props.form.values) };
    
    const valuesTGT = {entryType: 'Purchase', month:renderMonth(this.state.monthNum),  ...(this.props.form !== undefined && this.props.form.values)  ,search: 'totalGT'};
    
  this.props.searchPurchaseBook(values,limit);
  this.props.searchPurchaseBook(valuesTGT,limit);
  
  }
  componentWillUnmount(){
    this.props.resetForm('PurchaseBookSearch')
    this.props.resetLoading()
  }

  handleSearchPurchaseBook = () => {
    this.props.openModal("SearchPurchaseBookModal");
  };

  show = (id , path,entryType,idOfContraEntry) => {

    this.setState({ open: true, id: id, path:path,entryType:entryType,idOfContraEntry:idOfContraEntry });
  };

  

  handleRefresh = ()=>{
    const {offset, limit} = this.props;
    const values = {entryType: 'Purchase', month:this.props.accountMonth,  ...(this.props.form !== undefined && this.props.form.values) };
    this.props.searchPurchaseBook(values, limit,offset)
  }

handleRefreshAll = ()=>{
  const {offset, limit} = this.props;
  const values = {entryType: 'Purchase', month:this.props.accountMonth,  ...(this.props.form !== undefined && this.props.form.values) };
  this.props.searchPurchaseBook(values, limit,offset)

  const valuesTGT = {entryType: 'Purchase', month:this.props.accountMonth,  ...(this.props.form !== undefined && this.props.form.values)  ,search: 'totalGT'};
  this.props.searchPurchaseBook(valuesTGT, limit,offset)

}



handleConfirm = async () => {
  const did = this.state.id;
  const  value = {paths:this.state.path}
  const  valueDel = {entryType:this.state.entryType,idOfContraEntry:this.state.idOfContraEntry}
  const imageURL_F =()=>{
    if(this.state.path.length >0){
      return this.state.path[0].substr(0, 23)
    }
  }

//************
try {
  if(this.state.path.length >0){
  const resImage = await axios.post(`${imageURL_F()}/api/ImageDeleteAllContra`, value);
    if(resImage.data.msg ==='success'){
      const res = await axios.put(`/api/FinanceDelete/${did}`,valueDel);

      if(res.data.msg ==='success'){
        this.handleRefreshAll()
        this.setState({ result: "confirmed", open: false });
        toastr.success('Deleted Successfully')
        }
    }
  }
  //^^^^^^^^^^^
  if(this.state.path.length <1){

    const res = await axios.put(`/api/FinanceDelete/${did}`,valueDel);

      if(res.data.msg ==='success'){
        this.handleRefreshAll()
        this.setState({ result: "confirmed", open: false });
        toastr.success('Deleted Successfully')
        }
    }



  }catch (error) {
 toastr.error("Oops", "Something went wrong.Please Try Again");
}
//**********
};
  handleCancel = () => this.setState({ result: "cancelled", open: false });
//**********************************
  handleEditModalOpen = (id) => this.setState({ editModalOpen:true, id:id })
  handleEditModalClose = () =>{
     this.setState({ editModalOpen:false })
        }  //
  handleEditModalCloseSubmit = () =>{
    this.handleRefreshAll()
          this.setState({ editModalOpen:false })
  }
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
handleFinanceEditToAcceptModalOpen = (id) => this.setState({ financeEditToAcceptModalOpen:true, id:id })
handleFinanceEditToAcceptModalClose = () =>{
   this.setState({ financeEditToAcceptModalOpen:false })
    }  //
handleFinanceEditToAcceptModalCloseSubmit = () =>{
  this.handleRefresh()
      this.setState({ financeEditToAcceptModalOpen:false })
}
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
handleAllFinanceSAModalOpen = (accountId,month) => this.setState({ allFinanceSAModalOpen:true, accountId,month});
handleAllFinanceSAModalClose = () => {
  this.setState({ allFinanceSAModalOpen:false, })
};
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
handleAddViewImageModalOpen = (id,idContra,path,entryFor,entryType) => this.setState({ addViewImageModalOpen:true, id:id,idOfContraEntry:idContra,imagePathContra:path,entryFor,entryType})
handleAddViewImageModalClose = () => this.setState({ addViewImageModalOpen:false, })
//************
// handleViewPdfModalOpen = (id,idContra,path,checkedStatus,entryFor,entryType) => this.setState({ viewPdfModalOpen:true, id:id,idOfContraEntry:idContra,imagePathContra:path,checkedStatus,entryFor,entryType})
// handleViewPdfModalClose = () => this.setState({ viewPdfModalOpen:false, })


//**************************************
renderButton = (deleteEntry,id,path,entryType,idOfContraEntry) =>{
  if(  this.props.userA !== null &&
  (this.props.userA.purchaseDelete === "Yes" ||
    this.props.userA.userType === "admin") ){
      if(deleteEntry ===false){
        return (
            <span></span>
      )
    }else{
      return (
        <span
        onClick={() => this.show(id,path,entryType,idOfContraEntry)}
        className="icon-button"
        >
        <img className= 'yimg ' src='/deleteIcon.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
        </span>

    )
    }
  }else{
    return(
      <span></span>
    )
  }
}

//******************
renderAddOrViewImageButton = (id,idContra,path,checkedStatus,entryFor,entryType) =>{

if(path !== undefined && path.length <1){
 return (
 <span
 onClick={()=>this.handleAddViewImageModalOpen(id,idContra,path,checkedStatus,entryFor,entryType)}
 className="icon-button"
 >
 <img className= 'yimg ' src='/imageAddIcon.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
 </span>

)
}
//***
if(path !== undefined && path.length >0){
 if(path[0].indexOf('image') !== -1){
 return (
 <span
   onClick={()=>this.handleAddViewImageModalOpen(id,idContra,path,checkedStatus,entryFor,entryType)}
 className="icon-button"
 >
 <img className= 'yimg ' src='/imageViewIcon.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
 </span>

);
}
//^^
if(path[0].indexOf('pdf') !== -1){
return (
<span
 onClick={()=>this.handleAddViewImageModalOpen(id,idContra,path,checkedStatus,entryFor,entryType)}
 //onClick={()=>this.handleViewPdfModalOpen(id,idContra,path,checkedStatus,entryFor,entryType)}
className="icon-button"
>
<img className= 'yimg ' src='/pdfViewIcon.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
</span>

);
}
//^^
}
//**

}
  //###################################
  renderCheckedStatusButton = (entryType,checkedStatus,id) =>{
   
   if(checkedStatus==='Not Checked'){
     
     if((entryType==='Purchase')||(entryType==='Purchase Return')){
       return (
         <span
         onClick={()=>this.handleFinanceEditToAcceptModalOpen(id)}
         className="icon-button"
         >
         <img className= {this.nameClass(entryType)} src='/statusIconOnHold.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
         </span>
       )
     }

   }
   if(checkedStatus==='Checked Ok'){
     
     if((entryType==='Purchase')||(entryType==='Purchase Return')){

         return (
           <span
          //  onClick={()=>this.handleFinanceEditToAcceptModalOpen(id)}
           className="icon-button"
           >
           <img className= 'yimg btn-disabled' src='/statusIconOk.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
           </span>
         )
         }
   }
  //  if(checkedStatus==='Checked Not Ok'){
     

  //    if((entryType==='Purchase')||(entryType==='Purchase Return')){
  //      return (
  //        <span
  //        onClick={()=>this.handleFinanceEditToAcceptModalOpen(id)}
  //        className="icon-button "
  //        >
  //        <img className= {this.nameClass(entryType)} src='/statusIconNotOk.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
  //        </span>
  //      )
  //    }
  //  }
  //  if(checkedStatus==='Unlocked'){
     

  //    if((entryType==='Purchase')||(entryType==='Purchase Return')){
  //      return (
  //        <span
  //        onClick={()=>this.handleFinanceEditToAcceptModalOpen(id)}
  //        className="icon-button "
  //        >
  //        <img className= {this.nameClass(entryType)} src='/statusIconInProgress.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
  //        </span>
  //      )
  //    }
  //  }
    // if statement last bracket
   //^^^^^^^^^^^ last bracket
 }


 //^^^^^^^^^^^^^^^
  nameClass =(entryType)=>{
   
   if((entryType==='Purchase')||(entryType==='Purchase Return')){
     return 'yimg '
   }
 }
  // ^^^^^^^^^^^^^^^
  onChange=(e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
//*******************************************************
  renderList=(finance)=> {
    const {
      entryType,
      description,
      //accountName,
      accountId,
      // bankAccountName,
      // transactionType,
      //accountRef,
      amount,
      entryDate,
   
      imagePathContra,
      idOfContraEntry,
      checkedStatus,
      deleteEntry,
      _id
    } = finance;

    const userType = this.props.userA !== null && this.props.userA.userType
    const accountDetail = this.props.usersG !== undefined && this.props.usersG !== null && this.props.usersG !==undefined && this.props.usersG.filter(val => {
  
        return val._id === accountId.toString();
      })[0];

                // //^^^^^^^^^^^^^^^
    return (
      <Table.Row   key={_id}>
        <Table.Cell>{format(new Date(entryDate), "MMM d yyyy")}</Table.Cell>
        <Table.Cell>
          <>
          <span 
        className="color-indigo font-14B underline cursor-pointer"
        onClick={()=>this.props.openModal('UserDetailModal',{id:accountId})}
       > 
         {userType==='Shop Owner'? accountDetail!== undefined && accountDetail.uname : accountDetail!== undefined && accountDetail.shopName}{' '}({accountDetail!== undefined && accountDetail.address}{' '}{userType==='Shop Owner'? '#'.concat(accountDetail!== undefined && accountDetail.userId):''})
        </span>
        </>
        </Table.Cell>
        <Table.Cell>{description && capitalizeFirst(description)}</Table.Cell>

        {/* <Table.Cell>{accountRef}</Table.Cell> */}
        <Table.Cell>{amount}</Table.Cell>
        <Table.Cell>
        <div className='disflex-paginator'>
        <span
        className="icon-button ml-20"
        onClick={()=>this.handleAllFinanceSAModalOpen(accountId,this.props.accountMonth)}
        >
        <img className= 'yimg ' src='/inrIcon.jpg' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
        </span>
        <span
        onClick={()=>this.handleEditModalOpen(_id)}
        className="icon-button"
        >
        <img className= 'yimg ' src='/editIcon.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
        </span>
        {this.renderButton(deleteEntry , _id,imagePathContra,entryType,idOfContraEntry)}
        {/* {this.renderAddOrViewImageButton(_id,idOfContraEntry,imagePathContra,entryFor,entryType)} */}
        { this.renderCheckedStatusButton(entryType,checkedStatus,_id)}

          </div>
        </Table.Cell>
      </Table.Row>
    );
  }
//*********************************** for mobile
renderListMobile=(finance)=> {
  const {
    entryType,
    description,
    accountName,
    accountId,
    // bankAccountName,
    // transactionType,
    //accountRef,
    amount,
    entryDate,
 
    imagePathContra,
    idOfContraEntry,
    checkedStatus,
    deleteEntry,
    _id
  } = finance;

    
  const colorRibbon = ((entryType === 'Purchase')) ? 'blue': 'black';
  
  const userType = this.props.userA !== null && this.props.userA.userType
  const accountDetail = this.props.usersG !== undefined && this.props.usersG !== null && this.props.usersG !==undefined && this.props.usersG.filter(val => {

      return val._id === accountId.toString();
    })[0];
    //******************


  return (
    <Segment key={_id}>
      <Label color={colorRibbon} ribbon>
{entryType}
      </Label>
      
      <span
        className="icon-button ml-20"
        onClick={()=>this.handleAllFinanceSAModalOpen(accountId,this.props.accountMonth)}
        >
        <img className= 'yimg ' src='/inrIcon.jpg' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
        </span>
      
      <span
      onClick={()=>this.handleEditModalOpen(_id)}
      className="icon-button"
      >
      <img className= 'yimg ' src='/editIcon.png' alt=" " style={{width:"25px", height:"25px",borderRadius:'5px',verticalAlign:'middle'}} />
      </span>
      {this.renderButton(deleteEntry , _id,imagePathContra,entryType,idOfContraEntry)}
      {/* {this.renderAddOrViewImageButton(_id,idOfContraEntry,imagePathContra,entryFor,entryType)} */}
      { this.renderCheckedStatusButton(entryType,checkedStatus,_id)}


       
      <br /><br/>


      <Divider fitted />

      <div >
      {entryDate && (
        <div className='row'>
        <div className='side'>
          <b>Date</b>
        </div>
        <div className='main'>

        <b>{format(new Date(entryDate), "MMM d yyyy")}
        </b>
        </div>

        </div>
      )}
      </div>

      <div   >
      {entryType && (
        <div className='row'>
        <div className='side'>
          <b>Entry Type</b>
        </div>
        <div className='main color-date'>

        <b>{entryType}
        </b>
        </div>

        </div>
      )}
      </div>

      <div >
      {accountName && (
        <div className='row'>
        <div className='side'>
          <b>Account Name</b>
        </div>
        <div 
        onClick={()=>this.props.openModal('UserDetailModal',{id:accountId})}
        className='main'>
        <b className="color-indigo">
        {userType==='Shop Owner'? accountDetail!== undefined && accountDetail.uname : accountDetail!== undefined && accountDetail.shopName}{' '}({accountDetail!== undefined && accountDetail.address}{' '}{userType==='Shop Owner'? '#'.concat(accountDetail!== undefined && accountDetail.userId):''})
          </b>
        </div>

        </div>
      )}
      </div>

      <div >
      {description && (
        <div className='row'>
        <div className='side'>
          <b>Description</b>
        </div>
        <div className='main'>
          <b>{capitalizeFirst(description)}</b>
        </div>

        </div>
      )}
      </div>

      {/*<div >
      {bankAccountName && (
        <div className='row'>
        <div className='side'>
          <b>Bank Account Name</b>
        </div>
        <div className='main'>
          <b>{bankAccountName}</b>
        </div>

        </div>
      )}
      </div>*/}

      {/* <div >
      {accountRef && (
        <div className='row'>
        <div className='side'>
          <b>Entry Ref</b>
        </div>
        <div className='main'>
          <b>{accountRef}</b>
        </div>

        </div>
      )}
      </div> */}

      {/*<div >
      {transactionType && (
        <div className='row'>
        <div className='side'>
          <b>Transaction Type</b>
        </div>
        <div className='main'>
          <b>{transactionType}</b>
        </div>

        </div>
      )}
      </div>*/}

      <div >
      {amount && (
        <div className='row'>
        <div className='side'>
          <b>Amount INR</b>
        </div>
        <div className='main'>
          <b>{amount}{' '}(   {capitalizeFirst(writtenNumber(amount, {
      lang: "enIndian"
    }))}  )
          {" "}</b>
        </div>

        </div>
      )}
      </div>


    </Segment>
  );
}

//**********************
  back = () => {
    const {
      offset,
      limit

    } = this.props;

    const values = {entryType: 'Purchase', month:this.props.accountMonth,  ...(this.props.form !== undefined && this.props.form.values) };
    

    if (offset === 0) {
      return;
    }

    this.props.searchPurchaseBook(values, limit, (offset - limit));
    window.scroll(0,11000)
  };

  advance = () => {
    const {
      offset,
      limit,
      count

    } = this.props;

    const values = {entryType: 'Purchase', month:this.props.accountMonth,  ...(this.props.form !== undefined && this.props.form.values) };
    
    if (offset + limit > count) {
      return;
    }

    this.props.searchPurchaseBook(values, limit, (offset + limit));
    window.scroll(0,0)
  };
  handleGoToPage = () => {
    const {

      limit,
      count

    } = this.props;

    const values = {entryType: 'Purchase', month:this.props.accountMonth,  ...(this.props.form !== undefined && this.props.form.values) };
    
      // use Math.abs for strict equality ===  to work and safe guard against negative value from user
      if (Math.abs(this.state.pageO) === 0) {
        return;
      }

    const page=(Math.abs(this.state.pageO*limit) > count)?(Math.ceil(count/limit-1)):(Math.abs(this.state.pageO)-1)


    this.props.searchPurchaseBook(values, limit, (page * limit));
      window.scroll(0,0)

  };

  //****************** */
  renderPaginator() {
    if (this.props.purchaseBooks.length) {
      return (
        <Paginator
          advance={this.advance}
          back={this.back}
          offset={this.props.offset}
          limit={this.props.limit}
          count={this.props.count}
        />
      );
    }
  }


    renderLoading() {
      if (this.props.fetching===true) {
        return (
          <Container text>
        <div><span style={{marginLeft: '200px',fontSize: "18px",color: "teal"}}><b>Loading...</b></span>

        </div>
        </Container>
        );
      }
    }
    renderNoEntry() {
      if (this.props.noEntry===true) {
        return (
          <>
          <Table.Row className="nodisplay-at-mobile disflex-center">
            <Table.Cell>
            <span className="font-20B color-dodgerblue">No Entry Exist</span>
            </Table.Cell>
          </Table.Row>
        <Segment className="nodisplay-at-tab disflex-center"><span className="font-20B color-dodgerblue">No Entry Exist</span></Segment>
        </>
        );
      }
    }
  //########## RENDER ###############################
  render() {

   
// //const BalancePurchase = this.props.BalancePurchase !==undefined && this.props.BalancePurchase
// const colorRibbon = this.props.purchaseBooks[0]!== undefined && ((this.props.purchaseBooks[0].entryType === 'Purchase')) ? 'blue': 'black'
// const EntryType = ()=>{
//   if(this.props.purchaseBooks[0]!== undefined && ((this.props.purchaseBooks[0].entryType === 'Purchase'))){
//     return 'Purchase'
//   }
//   if(this.props.purchaseBooks[0]!== undefined && ((this.props.purchaseBooks[0].entryType === 'Purchase Return'))){
//     return 'Purchase Return'
//   }

// }

    let sumT = this.props.purchaseBooks.reduce((acc, val) => acc + val.amount, 0);

    const { open,  } = this.state;

    
      return (
        <div >
        {/**/}
        <div >
        {/**/}

          <Confirm
             header='You Want To Delete !'
            size="mini"
            open={open}
            onCancel={this.handleCancel}
            onConfirm={() => this.handleConfirm()}
          />
        {/* EditCashBook Modal*/}

        <Modal
      open={this.state.editModalOpen}
      onClose={this.handleEditModalClose}
      basic
      closeOnEscape={false}
      closeOnDimmerClick={false}
      // size='small'
    >

      <Modal.Content>
      <PurchaseBookEdit
      id={this.state.id}
      month={this.props.accountMonth}
      handleEditModalCloseSubmit={this.handleEditModalCloseSubmit}
      handleEditModalClose= {this.handleEditModalClose}
       />

      </Modal.Content>

    </Modal>
    {/* FinanceEditToAccept Modal*/}

    <Modal
  open={this.state.financeEditToAcceptModalOpen}
  onClose={this.handleFinanceEditToAcceptModalClose}
  basic
  // closeOnEscape={false}
  // closeOnDimmerClick={false}
  // size='small'
>

  <Modal.Content>
  <FinanceEditToAccept
  id={this.state.id}
  month={this.props.accountMonth}
  handleFinanceEditToAcceptModalCloseSubmit={this.handleFinanceEditToAcceptModalCloseSubmit}
  handleFinanceEditToAcceptModalClose= {this.handleFinanceEditToAcceptModalClose}
   />

  </Modal.Content>

</Modal>
    {/* Add Image Modal*/}
    <Modal
    open={this.state.addViewImageModalOpen}
    onClose={this.handleAddViewImageModalClose}
    basic
    closeOnEscape={false}
    closeOnDimmerClick={false}
    // size='small'
    >

    <Modal.Content> 
    <AddViewImageContra
    idEnt={this.state.id}
    // idOfContraEntry={this.state.idOfContraEntry}
    // imagePathContra={this.state.imagePathContra}
    // checkedStatus={this.state.checkedStatus}
    // entryFor={this.state.entryFor}
    // entryType={this.state.entryType}
    handleAddViewImageModalClose= {this.handleAddViewImageModalClose}
    handleRefresh = {this.handleRefresh}
    />
    </Modal.Content>

    </Modal>
   
{/* AllFinanceSA Modal*/}
<Modal
        open={this.state.allFinanceSAModalOpen}
        onClose={this.handleAllFinanceSAModalClose}
        basic
        closeOnEscape={false}
        closeOnDimmerClick={false}
        style={{margin:'0px',padding:'0px'}}
        >

        <Modal.Content>
        <div className="mb-10"
style={{color:'white'}}
>
     
      <button

onClick={this.handleAllFinanceSAModalClose}

className='back-btn color-white'
>
<Icon name="arrow left" />

</button>
    </div>
        <AllFinanceSA 
        accountId = {this.state.accountId}
        month = {this.state.month} 
        handleAllFinanceSAModalClose = {this.handleAllFinanceSAModalClose}
       
        />

        </Modal.Content>
        </Modal>

         {/* AllFinanceSA Modal end*/}
    {/**/}
    </div >
    {/**/}
        <div className='nodisplay'>

        <Container  >
                    {/**/}
                    <div className='cashbook-H'>

                    <div
            style={{display: 'flex',flex: '15%',justifyContent: 'center',alignItems: 'center',}}
            onClick={this.handleRefresh}>
                  <span className='icon-button px-10 border1' > <Icon name='refresh' />Refresh</span >
                </div>

            <div  style={{display: 'flex',flex: '75%',justifyContent: 'center',}} >
            <div   style={{display: 'flex',justifyContent: 'center',fontSize:'1.3rem',fontWeight:'bold',padding:'5px'}}  >
              Purchase Book # {this.props.accountMonth}
            </div>
            </div>

            <div
            style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',}}
            onClick={this.handleSearchPurchaseBook}>
                  <span className='icon-button px-10 border1' > <Icon name='search' />Search</span >
                </div>


            </div>
            {/**/}
          <Segment  attached>
          {/* <div >
            <Label color={colorRibbon} ribbon="right"  >
            {" "}
              {EntryType()}
            </Label>
            </div> */}
            

            {this.renderLoading()}
            <Table compact="very" celled striped >
              <Table.Header>
                <Table.Row>
                <Table.HeaderCell>Date</Table.HeaderCell>
                <Table.HeaderCell>A/C Name</Table.HeaderCell>
                <Table.HeaderCell>Description</Table.HeaderCell>

                {/* <Table.HeaderCell>Entry Ref</Table.HeaderCell> */}
                <Table.HeaderCell>Amount <Icon className="rupee" ></Icon></Table.HeaderCell>
                <Table.HeaderCell>Action</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>

                {this.props.purchaseBooks.map(this.renderList)}
                {this.renderNoEntry()}
              </Table.Body>

              <Table.Footer>
                <Table.Row>
                  {/* <Table.HeaderCell /> */}
                  <Table.HeaderCell><span className='color-date'>

                  <Popup trigger={<span className="border-circle mr-05">?</span>
                  } wide='very'>
                  <b>Total of the all entries For current Search Criteria</b>
                  </Popup>
                  <b>Grand Total</b></span></Table.HeaderCell>
                  <Table.HeaderCell><span style={{color:'blue'}}><b><Icon className="rupee" ></Icon></b><b>{this.props.sumGTotalPurchase}</b></span></Table.HeaderCell>

                  <Table.HeaderCell><span style={{color:'teal'}}>

                  <Popup trigger={<span className="border-circle mr-05">?</span>
                  } wide='very'>
                  <b>Total of the all entries on the current page</b>
                  </Popup>
                  <b>Total</b></span></Table.HeaderCell>
                  <Table.HeaderCell><span style={{color:'blue'}}><b><Icon className="rupee" ></Icon>{sumT}</b></span></Table.HeaderCell>
                  <Table.HeaderCell />

                </Table.Row>
              </Table.Footer>
            </Table>

          </Segment>
          <Segment style={{ marginLeft: '0px' }}>
          <div className='disflex-paginator '>
{this.renderPaginator()}
<div className="disflex-paginator mb-0">
  <div className= 'font-paginator'>Go To Page</div>
  <form>
<input
className='inputPage'
placeholder="number"
name="pageO"
type="number"
value={this.state.pageO}
onChange={this.onChange}
/>
<span  className="btnNumber"  onClick={this.handleGoToPage} >
Submit
</span>
</form>

</div>

</div>
          </Segment>
        </Container>
</div>

<div className='nodisplay-tab'>

        <Container text className='marginBottom-25'>

          {/**/}
          <div className='cashbook-H'>

          <div
            style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',}}
            onClick={this.handleRefresh}>
                  <span className='icon-button px-05 ml-05 border1' > <Icon name='refresh' /></span >
                </div>

        <div  style={{display: 'flex',flex: '80%',justifyContent: 'center',}} >
        <div   style={{display: 'flex',justifyContent: 'center',fontSize:'1.3rem',fontWeight:'bold',padding:'5px'}}  >
        Purchase Book # {this.props.accountMonth }
       </div>
       </div>

       <div
       style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',}}
       onClick={this.handleSearchPurchaseBook}>
              <span className='icon-button px-05 border1' > <Icon name='search' /></span >
            </div>


       </div>
       {/**/}
          <Segment  attached>

          
            

  </Segment>
              {this.renderLoading()}
                {this.props.purchaseBooks.map(this.renderListMobile)}
                {this.renderNoEntry()}

          <Segment >
          <div className='display-flex-fin font-18B'>
          <div className='sideF'>
          <Popup trigger={<span className="border-circle mr-05">?</span>
          } wide='very'>
          <b>Total of the all entries on the current page</b>
          </Popup>
          <b><span>Total : <Icon className="rupee" ></Icon>{sumT}{' '}</span>
          <span style={{color:'blue'}} >( {' '}{capitalizeFirst(writtenNumber(Math.abs(sumT), {
          lang: "enIndian"
          }))} )</span>
          </b></div>
          <Divider/>
          <div className='sideF' >
          <Popup trigger={<span className="border-circle mr-05">?</span>
          } wide='very'>
          <b>Total of the all entries For current Search Criteria</b>
          </Popup>
          <b><span style={{color:'blue'}}>Grand Total </span> : <span> <Icon className="rupee" ></Icon>{this.props.sumGTotalPurchase}{' '}</span>
          <span style={{color:'blue'}} >( {' '}{capitalizeFirst(writtenNumber(Math.abs(this.props.sumGTotalPurchase !==undefined && this.props.sumGTotalPurchase), {
          lang: "enIndian"
          }))} )</span>
          </b></div>

          </div>

        

          </Segment>

{/*  */}
      
<div className='disflex-paginator card-paginator media-600'>
      {this.renderPaginator()}
      <div className="disflex-paginator" >
        <div className= 'font-paginator'>Go To Page</div>
        <form>
              <input
              className='inputPage'
                placeholder="number"
                name="pageO"
                type="number"
                value={this.state.pageO}
                onChange={this.onChange}
              />
              <span  className="btnNumber"  onClick={this.handleGoToPage} >
                Submit
              </span>
            </form>
      
              
      </div>
      <br/>
      </div>
      
      {/*  */}
     
      {/* <AdFindprop
      className1={"font-18B color-yellow pxy-10 font-family-bellMT"}
      className2={"font-18B color-white pxy-10 font-family-Calibri"}
      /> */}
      {/*  */}

        </Container>
        </div>
        </div>
      );
    }

    
}


const mapStateToProps = ({ finances, auth, form, }) => {
  const {accountMonth,noEntry,  fetching, offsetPurchase,limit, countPurchase } = finances;

  return {
    fetching,
    noEntry,
    limit,
    offset:offsetPurchase,
    count:countPurchase,
    accountMonth, 
    usersG: auth.usersG,
    form:form.PurchaseBookSearch,
    userA: auth.userA,
    purchaseBooks: finances.purchaseBooks,
    sumGTotalPurchase: finances.sumGTotalPurchase,
  };
};

export default connect(
  mapStateToProps,
{  ...actions,openModal,resetForm, }
)(PurchaseBook);
